import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    selectGroup: {
      display: 'flex',
      width: 'calc(100% - 20px)',
      margin: '0px 10px',
      '& .MuiOutlinedInput-root': {
        color: props.color1,
        height: 34,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: `2px solid ${props.color2} !important`,
      },
      '& .select > svg': {
        fill: props.color1,
        fontSize: 20,
        marginTop: 2
      }
    },
    invalid: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: '2px solid red !important',
      },
      '& .select > svg': {
        fill: 'red !important'
      },
      '& .select ': {
        color: 'red'
      }
    },
  }));
  return styles();
}
export default theme;

